<template>
  <div>
    <create-card route_back="ClientPortfolios" model_name="carteira de clientes" :saving="saving">
      <template slot="form">
          <v-form lazy-validation v-model="valid">
            <v-stepper v-model="stepper" vertical class="ml-1 mr-1 elevation-0 d-flex flex-column">
              
              <v-stepper-step step="1" :editable="stepper > 1"> Informações da carteira de clientes <small>Nome, status e tipo</small></v-stepper-step>
              <v-stepper-content step="1" >
                  <v-card color="white lighten-1" class="ma-3">
                    <v-card-text>
                      <ClientsPortfolioInfoForm ref="step1" :client_portfolio="client_portfolio"></ClientsPortfolioInfoForm>
                    </v-card-text>
                  </v-card>
                  <v-btn text disabled><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
                  <v-btn text @click="nextStep('step1')"><v-icon class="rodar-dow" large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
              </v-stepper-content>
    
              <v-stepper-step step="2" :editable="stepper > 2">Clientes <small>Selecione os clientes da carteira</small> </v-stepper-step>
              <v-stepper-content step="2">
                <v-card color="white lighten-1" class="ma-3">
                  <v-card-text>
                    <ClientPortfolioSelectClients ref="step2" :client_portfolio="client_portfolio"></ClientPortfolioSelectClients>
                  </v-card-text>
                </v-card>
                <v-btn text @click="stepper = 1"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
                <v-btn text @click="nextStep('step2')"><v-icon class="rodar-dow" large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
              </v-stepper-content>
    
              <v-stepper-step step="3">Funcionários<small>Selecione os funcionários que usam a carteira</small></v-stepper-step>
              <v-stepper-content step="3">
                <v-card color="white lighten-1" class="ma-3">
                  <v-card-text>
                    <ClientPortfolioSelectEmployees ref="step3" :client_portfolio="client_portfolio"></ClientPortfolioSelectEmployees>
                  </v-card-text>
                </v-card>
                <v-btn text @click="stepper = 2"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
                <v-btn color="success" @click="submitClientPortfolio()" :loading="saving">Salvar</v-btn>
              </v-stepper-content>

            </v-stepper>
          </v-form>
      </template>
    </create-card>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Api from '@/api/index';
import validations from '@/mixins/validations'

export default {
  name: 'CreateClientPortfolios',
  mixins: [ validations ],

  components:{
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    ClientsPortfolioInfoForm: () => import("@/_backoffice/_registrations/components/client_portfolio/forms/ClientsPortfolioInfoForm.vue"),
    ClientPortfolioSelectClients: () => import("@/_backoffice/_registrations/components/client_portfolio/forms/ClientPortfolioSelectClients.vue"),
    ClientPortfolioSelectEmployees: () => import("@/_backoffice/_registrations/components/client_portfolio/forms/ClientPortfolioSelectEmployees.vue"),
  },
  data() {
    return {
      valid: true,
      stepper: 1,
      saving: false,
      loading: false,
      client_portfolio:{
        name: "",
        status: 'active',
        kind: 'manual',
        client_ids:[],
        employee_ids:[],
        module_ids:[],
      }
    }
  },
  methods: {
    nextStep(step){
      if(this.$refs[step].validate()){
        this.stepper ++
      }
      else{
        this.addNotification({type: 'error', msg: 'Preencha o todos os campos válidos.'})
      }
    },
    submitClientPortfolio() {
      if (this.$refs.step1.validate() && this.$refs.step2.validate() && this.$refs.step3.validate()) {
        this.swallConfirmation({
          title: 'Deseja criar carteira de clientes?',
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            this.saving = true
            Api.ClientPortfolio.create(this.client_portfolio).then(response => response.data).then(client_portfolio => {
              this.addNotification({type: 'success',  msg: `Carteira de clientes cadastrada com sucesso!`})
              this.$router.push({name:"ClientPortfolios"})
            }).catch((err) => {
              this.addNotification({type: 'error',  msg: `Ocorreu um erro, a Carteira de clientes não pode ser cadastrada!`})
            }).finally(() => {
              this.saving = false
            });
          }
        })
      }else{
        this.addNotification({type: 'error',  msg: `Alguns campos não foram preenchidos.`})
      }
    },
    ...mapActions({
      addNotification: 'Notification/add'
    })
  },
}
</script>